/* KENT cart: hide "Complete the set" items that are already in the cart.
   The drawer is built from a page-load template, so it can be out of date. */
(function () {
  var busy = false;
  function refresh() {
    var items = document.querySelectorAll('[data-kent-upsell-product]');
    if (!items.length || busy) return;
    busy = true;
    fetch((window.theme && theme.routes && theme.routes.cart_url ? theme.routes.cart_url : '/cart') + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var inCart = {};
        (cart.items || []).forEach(function (i) { inCart[String(i.product_id)] = true; });
        document.querySelectorAll('[data-kent-upsell-product]').forEach(function (li) {
          li.hidden = !!inCart[li.getAttribute('data-kent-upsell-product')];
        });
        document.querySelectorAll('.kent-upsell').forEach(function (box) {
          box.hidden = !box.querySelector('[data-kent-upsell-product]:not([hidden])');
        });
      })
      .catch(function () {})
      .then(function () { busy = false; });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-kent-upsell-add]');
    if (!btn) return;
    e.preventDefault();
    var box = btn.closest('[data-kent-upsell-form]');
    var sel = box && box.querySelector('[data-kent-upsell-variant]');
    if (!sel || !sel.value) {
      var sizes = box && box.querySelector('.kent-upsell__sizes');
      if (sizes) { sizes.classList.add('needs-size'); setTimeout(function () { sizes.classList.remove('needs-size'); }, 1600); }
      return;
    }
    btn.disabled = true;
    var label = btn.textContent;
    btn.textContent = '…';
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(sel.value), quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (window.cart && typeof window.cart.getCart === 'function') window.cart.getCart();
        document.dispatchEvent(new CustomEvent('cart:add-item', { bubbles: true }));
        var li = btn.closest('[data-kent-upsell-product]');
        if (li) li.hidden = true;
        soon();
      })
      .catch(function () {})
      .then(function () { btn.disabled = false; btn.textContent = label; });
  });

  var t;
  function soon() { clearTimeout(t); t = setTimeout(refresh, 400); }
  document.addEventListener('cart:add-item', soon);
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-toggle], .kent-upsell__add, [data-add-to-cart]')) setTimeout(soon, 900);
  });
  new MutationObserver(function (m) {
    for (var i = 0; i < m.length; i++) {
      for (var j = 0; j < m[i].addedNodes.length; j++) {
        var n = m[i].addedNodes[j];
        if (n.nodeType === 1 && (n.matches('[data-kent-upsell-product], .kent-upsell') || n.querySelector && n.querySelector('[data-kent-upsell-product]'))) { soon(); return; }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
  soon();
})();
